import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Grid, Spacer, Typography } from '@emburse/ui-core';
import * as style from './SignUpReviews.styl';
export const SignUpReviews = ({ initialSignupPage }) => {
    const reviews = initialSignupPage
        ? [
            {
                text: '"With Emburse Spend, we’ve gained more visibility into our operating expenses and increased control of our spend with a platform that can easily scale with us as we grow."',
                author: 'Morgan McLintic, CEO of Firebrand'
            },
            {
                text: '"We made it easier to volunteer for VoteRiders by using Emburse Spend to broaden access to organizational funds and reduce the need for personal reimbursements."',
                author: 'Shane Epps, Operations Manager, VoteRiders'
            },
            {
                text: '"The Emburse Spend system is great. We love the ease of managing both cards and users while consistently capturing essential expense details."',
                author: 'David Wendrychowicz, VP of Finance, GF Sports & Entertainment'
            }
        ]
        : [
            {
                text: '"With the increased visibility and control over spending, we have a huge increase in policy compliance."',
                author: 'Melanie Sacca, VP/Director of Finance, NAF'
            },
            {
                text: '"Emburse Cards is the best solution for a start-up company with limited access to traditional purchasing cards. Previously we were buying prepaid cards that were expensive, time-consuming, and provided poor visibility into spending."',
                author: 'Todd Paul, Controller, American Nitrile'
            }
        ];
    return (_jsx(Grid, Object.assign({ container: true, item: true, className: style.global, justifyContent: 'center' }, { children: _jsx(Grid, Object.assign({ container: true, item: true, alignItems: "center", wrap: "nowrap", spacing: 4, direction: "column" }, { children: reviews.map((review, i) => {
                return (_jsx(Grid, Object.assign({ item: true }, { children: _jsxs("div", Object.assign({ className: "review" }, { children: [_jsx(Typography, Object.assign({ variant: "body1" }, { children: review.text })), _jsx(Spacer, { size: '16px' }), _jsxs(Typography, Object.assign({ variant: "caption" }, { children: ["-- ", review.author] }))] })) }), i));
            }) })) })));
};
export default SignUpReviews;
